import React from 'react';
import { EmployerCertificateHeader } from './employer-certificate-header.component';
import { WorkHoursRequiredInfo } from './work-hours-required-info.component';
import { CertificatesTable } from './certificates-table.component';
import './employer-certificate-list.component.scss';

interface EmployerCertificateListProps {
    onOrderCertificate: () => void;
}

export const EmployerCertificateList: React.FC<EmployerCertificateListProps> = ({
    onOrderCertificate
}) => {
    const handleCreateTimesheet = () => {
        // TODO: Implement navigation to timesheet creation
        console.log('Create Timesheet clicked');
    };

    return (
        <div className="employer-certificate-list">
            <EmployerCertificateHeader />
            {/* <WorkHoursRequiredInfo onCreateTimesheet={handleCreateTimesheet} /> */}
            <CertificatesTable onOrderCertificate={onOrderCertificate} />
        </div>
    );
};
